import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './LandingPage.css';

// Images
import heroMerged from '../../assets/landing/images/merged.png';
import feature1 from '../../assets/landing/images/feature-1.png';
import feature2 from '../../assets/landing/images/feature-2.png';
import feature3 from '../../assets/landing/images/feature-3.png';
import phoneMockup from '../../assets/landing/images/phone-mockup.png';
import analyticsPerson from '../../assets/landing/images/analytics-person.png';

// Logos
import logo1 from '../../assets/landing/logos/logo-1.svg';
import logo2 from '../../assets/landing/logos/logo-2.svg';
import logo3 from '../../assets/landing/logos/logo-3.svg';
import logo4 from '../../assets/landing/logos/logo-4.svg';
import logo5 from '../../assets/landing/logos/logo-5.svg';
import logo6 from '../../assets/landing/logos/logo-6.svg';

// Logo SVG
import logoSvg from '../../assets/landing/icons/logo.svg';
import logoFooter from '../../assets/landing/icons/logo-footer.svg';

const LandingPage = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    company: '',
    teamSize: '',
    message: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <div className="landing-page">
      {/* Top accent bar */}
      <div className="top-accent-bar"></div>

      {/* Navigation Header */}
      <header className="landing-header">
        <div className="header-container">
          <div className="logo">
            <img src={logoSvg} alt="Marquee Couriers" />
          </div>

          <button
            className="mobile-menu-btn"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          <nav className={`header-nav ${mobileMenuOpen ? 'open' : ''}`}>
            <Link to="/login" className="btn-signin">
              <UserIcon />
              <span>Sign in</span>
            </Link>
            <Link to="/signup" className="btn-primary">
              <span>Get started</span>
              <ArrowIcon />
            </Link>
          </nav>
        </div>
      </header>

      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-container">
          <div className="hero-content" style={{ textAlign: 'left' }}>
            <span className="hero-badge">Marquee Couriers</span>
            <h1 className="landing-hero-title" style={{ textAlign: 'left' }}>Smarter, Faster, Verified Deliveries</h1>
            <p className="hero-subtitle" style={{ textAlign: 'left' }}>
              Dispatcher Web Console + Driver App + Customer Tracking. GPS-Stamped Photo Proof — No Signatures Required.
            </p>
            <div className="hero-ctas">
              <button className="btn-primary">
                <span>See It in Action</span>
                <ArrowIcon />
              </button>
              <button className="btn-outline">
                <span>Request a demo</span>
                <ArrowIcon />
              </button>
            </div>
            <div className="hero-social">
              <span>Join us across All Platforms :</span>
              <div className="social-icons">
                <LinkedInIcon />
                <XIcon />
                <EmailIcon />
                <YouTubeIcon />
                <FacebookIcon />
                <TikTokIcon />
                <InstagramIcon />
              </div>
            </div>
          </div>

          <div className="hero-image-wrapper">
            <img src={heroMerged} alt="Marquee Couriers platform overview" className="hero-merged-image" />
          </div>
        </div>
      </section>

      {/* Brand Logos */}
      <section className="brands-section">
        <div className="brands-container">
          <img src={logo1} alt="Partner logo" />
          <img src={logo2} alt="Partner logo" />
          <img src={logo3} alt="Partner logo" />
          <img src={logo4} alt="Partner logo" />
          <img src={logo5} alt="Partner logo" />
          <img src={logo6} alt="Partner logo" />
        </div>
      </section>

      {/* Why Section */}
      <section className="why-section">
        <h2 className="section-title">Why a New Courier Platform?</h2>
        <div className="why-cards">
          <div className="why-card">
            <div className="why-icon">
              <LocationPinIcon />
            </div>
            <h3>GPS-Stamped Photo Proof</h3>
            <p>GPS Live Tracking</p>
          </div>
          <div className="why-card">
            <div className="why-icon">
              <TruckIcon />
            </div>
            <h3>Live Driver Tracking & Route Replay</h3>
            <p>GPS Live Tracking</p>
          </div>
          <div className="why-card">
            <div className="why-icon">
              <DocumentIcon />
            </div>
            <h3>Instant Proof Packets & Reports</h3>
            <p>GPS Live Tracking</p>
          </div>
        </div>
      </section>

      {/* Features Section (Dark) */}
      <section className="features-section">
        <h2 className="section-title-light">Everything Dispatch Needs In One Place</h2>

        <div className="feature-row">
          <div className="feature-image">
            <img src={feature1} alt="Dispatch Web Console" />
          </div>
          <div className="feature-content">
            <div className="feature-icon-circle">
              <DashboardIcon />
              <h3>Dispatch Web Console</h3>
            </div>
   
            <p className="feature-description">
              Lorem Ipsum is simply dummy text of the printing and typesetting industry.
              Lorem Ipsum has been the industry's. standard dummy text ever since the 1500s,
              when an unknown printer took a galley.
            </p>
            <p className="feature-tags">Uploads Jobs, Assigning Routes, Monitor Live Maps</p>
          </div>
        </div>

        <div className="feature-row">
          <div className="feature-image">
            <img src={feature2} alt="Driver Mobile App" />
          </div>
          <div className="feature-content">
            <div className="feature-icon-circle">
              <PhoneIcon />
              <h3>Driver Mobile App</h3>
            </div>
            
            <p className="feature-description">
              Lorem Ipsum is simply dummy text of the printing and typesetting industry.
              Lorem Ipsum has been the industry's. standard dummy text ever since the 1500s,
              when an unknown printer took a galley.
            </p>
            <p className="feature-tags">Guided Workflow, Offline Modes, GPS Stamp & Auto Proof</p>
          </div>
        </div>

        <div className="feature-row">
          <div className="feature-image">
            <img src={feature3} alt="Customer Tracking Links" />
          </div>
          <div className="feature-content">
            <div className="feature-icon-circle">
              <TargetIcon />
                <h3>Customer Tracking Links</h3>
            </div>
          
            <p className="feature-description">
              Lorem Ipsum is simply dummy text of the printing and typesetting industry.
              Lorem Ipsum has been the industry's. standard dummy text ever since the 1500s,
              when an unknown printer took a galley.
            </p>
            <p className="feature-tags">Branded Pages With ETA Updates & Photo Proof Of Delivery</p>
          </div>
        </div>
      </section>

      {/* Analytics Section */}
      <section className="analytics-section">
        <h2 className="section-title-dark">Everything Dispatch Needs In One Place</h2>
        <p className="analytics-description">
              Lorem Ipsum is simply dummy text of the printing and typesetting industry
              Lorem Ipsum has been the industry's.
            </p>
        <div className="analytics-container">
          <div className="analytics-image">
            <div className="analytics-yellow-shape"></div>
            <img src={phoneMockup} alt="Analytics on phone" className="phone-mockup" />
            <img src={analyticsPerson} alt="Professional" className="analytics-person" />
          </div>
          <div className="analytics-content">
            
            <p className="analytics-detail">
              Lorem Ipsum is simply dummy text of the printing and typesetting industry.
              Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
              when an unknown printer took a galley.
            </p>
            <div className="analytics-stats">
              <div className="stat-item">
                <div className="stat-icon">
                  <ClockIcon />
                </div>
                <div className="stat-text">
                  <h4>Time track</h4>
                  <p>+0123 456 789</p>
                </div>
              </div>
              <div className="stat-item">
                <div className="stat-icon">
                  <PriceIcon />
                </div>
                <div className="stat-text">
                  <h4>Low rates</h4>
                  <p>+0123 456 789</p>
                </div>
              </div>
              <div className="stat-item">
                <div className="stat-icon">
                  <SaveTimeIcon />
                </div>
                <div className="stat-text">
                  <h4>Time saving</h4>
                  <p>MarqueCourier@gmail.com</p>
                </div>
              </div>
              <div className="stat-item">
                <div className="stat-icon">
                  <SecurityIcon />
                </div>
                <div className="stat-text">
                  <h4>Save & secure</h4>
                  <p>Marque Courier insta</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Demo Section (Dark) */}
      <section className="demo-section">
        <div className="demo-container">
          <div className="demo-content">
            <h2>Proof You Can Rely On</h2>
            <p className="demo-subtitle">
              We'll walk through the Dispatcher Console and Driver App in a 30-minute
              session tailored to your workflows.
            </p>
            <div className="proof-features">
              <div className="proof-item">
                <div className="proof-icon">
                  <TamperIcon />
                </div>
                <div className="proof-text">
                  <h4>Tamper-Evident</h4>
                  <p>Tamper-Evident PDFs With GPS, Timestamp & Photos</p>
                </div>
              </div>
              <div className="proof-item">
                <div className="proof-icon">
                  <AuditIcon />
                </div>
                <div className="proof-text">
                  <h4>Immutable Audit</h4>
                  <p>Immutable Audit Trail With Cryptographic Hash</p>
                </div>
              </div>
              <div className="proof-item">
                <div className="proof-icon">
                  <SearchIcon />
                </div>
                <div className="proof-text">
                  <h4>Searchable</h4>
                  <p>Searchable Archive With Filters</p>
                </div>
              </div>
            </div>
          </div>
          <div className="demo-form-container">
            <form className="demo-form" onSubmit={handleSubmit}>
              <div className="form-row">
                <input
                  type="text"
                  name="fullName"
                  placeholder="Full name"
                  value={formData.fullName}
                  onChange={handleInputChange}
                />
                <input
                  type="email"
                  name="email"
                  placeholder="Work Email"
                  value={formData.email}
                  onChange={handleInputChange}
                />
              </div>
              <input
                type="text"
                name="company"
                placeholder="Company"
                value={formData.company}
                onChange={handleInputChange}
              />
              <select
                name="teamSize"
                value={formData.teamSize}
                onChange={handleInputChange}
              >
                <option value="">Team size</option>
                <option value="1-10">1-10</option>
                <option value="11-50">11-50</option>
                <option value="51-200">51-200</option>
                <option value="200+">200+</option>
              </select>
              <textarea
                name="message"
                placeholder="What problems are you trying to solve?"
                value={formData.message}
                onChange={handleInputChange}
                rows={4}
              />
              <button type="submit" className="btn-submit">
                Request Demo
              </button>
              <p className="form-terms">
                By submitting, you agree to our Terms and Privacy Policy.
              </p>
            </form>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="landing-footer">
        <div className="footer-divider"></div>
        <div className="footer-container">
          <div className="footer-logo">
            <img src={logoFooter} alt="Marquee Couriers" />
          </div>
          <div className="footer-social">
            <span>Join us across All Platforms :</span>
            <div className="social-icons light">
              <LinkedInIcon />
              <XIcon />
              <EmailIcon />
              <YouTubeIcon />
              <FacebookIcon />
              <TikTokIcon />
              <InstagramIcon />
            </div>
          </div>
          <div className="footer-apps">
            <button type="button" className="app-btn">
              <AppStoreIcon />
              <span>App store</span>
            </button>
            <button type="button" className="app-btn">
              <PlayStoreIcon />
              <span>Google play</span>
            </button>
          </div>
        </div>
      </footer>
    </div>
  );
};

// Icon Components
const ArrowIcon = () => (
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 8.5H13M13 8.5L8 3.5M13 8.5L8 13.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const UserIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 8C10.21 8 12 6.21 12 4C12 1.79 10.21 0 8 0C5.79 0 4 1.79 4 4C4 6.21 5.79 8 8 8ZM8 10C5.33 10 0 11.34 0 14V16H16V14C16 11.34 10.67 10 8 10Z" fill="#182030"/>
  </svg>
);

const LinkedInIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20.447 20.452H16.893V14.883C16.893 13.555 16.866 11.846 15.041 11.846C13.188 11.846 12.905 13.291 12.905 14.785V20.452H9.351V9H12.765V10.561H12.811C13.288 9.661 14.448 8.711 16.181 8.711C19.782 8.711 20.448 11.081 20.448 14.166V20.452H20.447ZM5.337 7.433C4.193 7.433 3.274 6.507 3.274 5.368C3.274 4.23 4.194 3.305 5.337 3.305C6.477 3.305 7.401 4.23 7.401 5.368C7.401 6.507 6.476 7.433 5.337 7.433ZM7.119 20.452H3.555V9H7.119V20.452Z" fill="currentColor"/>
  </svg>
);

const XIcon = () => (
  <svg width="14" height="13" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.244 2.25H21.552L14.325 10.51L22.827 21.75H16.17L10.956 14.933L4.99 21.75H1.68L9.41 12.915L1.254 2.25H8.08L12.793 8.481L18.244 2.25ZM17.083 19.77H18.916L7.084 4.126H5.117L17.083 19.77Z" fill="currentColor"/>
  </svg>
);

const EmailIcon = () => (
  <svg width="14" height="10" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M22 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H22C23.1 18 24 17.1 24 16V2C24 0.9 23.1 0 22 0ZM22 4L12 10L2 4V2L12 8L22 2V4Z" fill="currentColor"/>
  </svg>
);

const YouTubeIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M23.498 6.186C23.498 6.186 23.264 4.533 22.526 3.792C21.586 2.817 20.534 2.812 20.052 2.756C16.754 2.52 12.003 2.52 12.003 2.52H11.997C11.997 2.52 7.246 2.52 3.948 2.756C3.466 2.812 2.414 2.817 1.474 3.792C0.736 4.533 0.502 6.186 0.502 6.186C0.502 6.186 0.262 8.117 0.262 10.048V11.848C0.262 13.779 0.502 15.71 0.502 15.71C0.502 15.71 0.736 17.363 1.474 18.104C2.414 19.079 3.638 19.049 4.178 19.149C6.098 19.332 12 19.386 12 19.386C12 19.386 16.755 19.38 20.052 19.14C20.534 19.084 21.586 19.079 22.526 18.104C23.264 17.363 23.498 15.71 23.498 15.71C23.498 15.71 23.738 13.779 23.738 11.848V10.048C23.738 8.117 23.498 6.186 23.498 6.186ZM9.546 14.568V7.33L15.804 10.958L9.546 14.568Z" fill="currentColor"/>
  </svg>
);

const FacebookIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M24 12.073C24 5.405 18.627 0 12 0C5.373 0 0 5.405 0 12.073C0 18.1 4.388 23.094 10.125 24V15.563H7.078V12.073H10.125V9.413C10.125 6.387 11.917 4.716 14.658 4.716C15.97 4.716 17.344 4.95 17.344 4.95V7.921H15.831C14.339 7.921 13.875 8.852 13.875 9.808V12.073H17.203L16.671 15.563H13.875V24C19.612 23.094 24 18.1 24 12.073Z" fill="currentColor"/>
  </svg>
);

const TikTokIcon = () => (
  <svg width="12" height="13" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19.321 5.562C17.867 5.277 16.668 4.309 16.002 3.019C15.876 2.77 15.776 2.51 15.703 2.24V2H12.197V15.474C12.197 16.871 11.062 18.006 9.665 18.006C8.268 18.006 7.133 16.871 7.133 15.474C7.133 14.077 8.268 12.942 9.665 12.942C9.917 12.942 10.16 12.979 10.39 13.048V9.476C10.152 9.444 9.91 9.425 9.665 9.425C6.334 9.425 3.617 12.143 3.617 15.474C3.617 18.805 6.334 21.522 9.665 21.522C12.996 21.522 15.714 18.805 15.714 15.474V8.489C17.018 9.428 18.595 9.967 20.283 9.967V6.457C19.95 6.457 19.628 6.03 19.321 5.562Z" fill="currentColor"/>
  </svg>
);

const InstagramIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2.163C15.204 2.163 15.584 2.175 16.85 2.233C18.102 2.29 18.987 2.507 19.758 2.823C20.555 3.148 21.228 3.588 21.9 4.26C22.572 4.932 23.012 5.605 23.337 6.402C23.653 7.173 23.87 8.058 23.927 9.31C23.985 10.576 23.997 10.956 23.997 14.16C23.997 17.364 23.985 17.744 23.927 19.01C23.87 20.262 23.653 21.147 23.337 21.918C23.012 22.715 22.572 23.388 21.9 24.06C21.228 24.732 20.555 25.172 19.758 25.497C18.987 25.813 18.102 26.03 16.85 26.087C15.584 26.145 15.204 26.157 12 26.157C8.796 26.157 8.416 26.145 7.15 26.087C5.898 26.03 5.013 25.813 4.242 25.497C3.445 25.172 2.772 24.732 2.1 24.06C1.428 23.388 0.988 22.715 0.663 21.918C0.347 21.147 0.13 20.262 0.073 19.01C0.015 17.744 0.003 17.364 0.003 14.16C0.003 10.956 0.015 10.576 0.073 9.31C0.13 8.058 0.347 7.173 0.663 6.402C0.988 5.605 1.428 4.932 2.1 4.26C2.772 3.588 3.445 3.148 4.242 2.823C5.013 2.507 5.898 2.29 7.15 2.233C8.416 2.175 8.796 2.163 12 2.163ZM12 0C8.741 0 8.333 0.014 7.053 0.072C5.775 0.13 4.903 0.333 4.14 0.63C3.351 0.937 2.681 1.347 2.014 2.014C1.347 2.681 0.937 3.351 0.63 4.14C0.333 4.903 0.13 5.775 0.072 7.053C0.014 8.333 0 8.741 0 12C0 15.259 0.014 15.667 0.072 16.947C0.13 18.225 0.333 19.097 0.63 19.86C0.937 20.649 1.347 21.319 2.014 21.986C2.681 22.653 3.351 23.063 4.14 23.37C4.903 23.667 5.775 23.87 7.053 23.928C8.333 23.986 8.741 24 12 24C15.259 24 15.667 23.986 16.947 23.928C18.225 23.87 19.097 23.667 19.86 23.37C20.649 23.063 21.319 22.653 21.986 21.986C22.653 21.319 23.063 20.649 23.37 19.86C23.667 19.097 23.87 18.225 23.928 16.947C23.986 15.667 24 15.259 24 12C24 8.741 23.986 8.333 23.928 7.053C23.87 5.775 23.667 4.903 23.37 4.14C23.063 3.351 22.653 2.681 21.986 2.014C21.319 1.347 20.649 0.937 19.86 0.63C19.097 0.333 18.225 0.13 16.947 0.072C15.667 0.014 15.259 0 12 0ZM12 5.838C8.597 5.838 5.838 8.597 5.838 12C5.838 15.403 8.597 18.162 12 18.162C15.403 18.162 18.162 15.403 18.162 12C18.162 8.597 15.403 5.838 12 5.838ZM12 16C9.791 16 8 14.209 8 12C8 9.791 9.791 8 12 8C14.209 8 16 9.791 16 12C16 14.209 14.209 16 12 16ZM19.846 5.595C19.846 6.39 19.2 7.036 18.405 7.036C17.61 7.036 16.964 6.39 16.964 5.595C16.964 4.8 17.61 4.154 18.405 4.154C19.2 4.154 19.846 4.8 19.846 5.595Z" fill="currentColor"/>
  </svg>
);

const LocationPinIcon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="5" y="4" width="22" height="24" rx="2" stroke="#C9A32C" strokeWidth="2"/>
    <path d="M12 24V20" stroke="#C9A32C" strokeWidth="2" strokeLinecap="round"/>
    <path d="M21 20V28" stroke="#C9A32C" strokeWidth="2" strokeLinecap="round"/>
    <path d="M25 24H21" stroke="#C9A32C" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

const TruckIcon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="10" cy="22" r="3" stroke="#C9A32C" strokeWidth="2"/>
    <circle cx="22" cy="22" r="3" stroke="#C9A32C" strokeWidth="2"/>
    <path d="M4 8H20V19H4V8Z" stroke="#C9A32C" strokeWidth="2"/>
    <path d="M20 12H26L28 19H20V12Z" stroke="#C9A32C" strokeWidth="2"/>
  </svg>
);

const DocumentIcon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19 4H8C6.9 4 6 4.9 6 6V26C6 27.1 6.9 28 8 28H24C25.1 28 26 27.1 26 26V11L19 4Z" stroke="#C9A32C" strokeWidth="2"/>
    <path d="M19 4V11H26" stroke="#C9A32C" strokeWidth="2"/>
  </svg>
);

const DashboardIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="3" width="7" height="9" rx="1" stroke="#302F32" strokeWidth="2"/>
    <rect x="3" y="14" width="7" height="7" rx="1" stroke="#302F32" strokeWidth="2"/>
    <rect x="12" y="3" width="9" height="7" rx="1" stroke="#302F32" strokeWidth="2"/>
    <rect x="12" y="12" width="9" height="9" rx="1" stroke="#302F32" strokeWidth="2"/>
  </svg>
);

const PhoneIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="6" y="3" width="12" height="18" rx="2" stroke="#000000" strokeWidth="2"/>
    <line x1="11" y1="4" x2="13" y2="4" stroke="#000000" strokeWidth="2" strokeLinecap="round"/>
    <line x1="12" y1="17" x2="12" y2="18" stroke="#000000" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

const TargetIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="9" stroke="#000000" strokeWidth="2"/>
    <circle cx="12" cy="12" r="5" stroke="#000000" strokeWidth="2"/>
    <circle cx="12" cy="12" r="1" stroke="#000000" strokeWidth="2"/>
  </svg>
);

const ClockIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="9" stroke="#000000" strokeWidth="2"/>
    <path d="M12 7V12L15 15" stroke="#000000" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

const PriceIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="9" stroke="#000000" strokeWidth="2"/>
    <path d="M12 6V18M15 9C15 7.5 13.5 7 12 7C10.5 7 9 7.5 9 9C9 10.5 10.5 11 12 11C13.5 11 15 11.5 15 13C15 14.5 13.5 15 12 15C10.5 15 9 14.5 9 13" stroke="#000000" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

const SaveTimeIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 3V6M12 3L9 6M12 3L15 6" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <rect x="4" y="6" width="16" height="14" rx="2" stroke="#000000" strokeWidth="2"/>
  </svg>
);

const SecurityIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 3L4 7V12C4 16.4 7.4 20.5 12 21.5C16.6 20.5 20 16.4 20 12V7L12 3Z" stroke="#000000" strokeWidth="2"/>
    <path d="M9 12L11 14L15 10" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const TamperIcon = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="3" width="18" height="18" rx="2" stroke="#000000" strokeWidth="2"/>
    <path d="M12 4V8" stroke="#000000" strokeWidth="2" strokeLinecap="round"/>
    <path d="M8 12H16" stroke="#000000" strokeWidth="2" strokeLinecap="round"/>
    <path d="M20 15H22" stroke="#000000" strokeWidth="2" strokeLinecap="round"/>
    <path d="M20 18H22" stroke="#000000" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

const AuditIcon = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="4" y="4" width="6" height="6" stroke="#000000" strokeWidth="2"/>
    <rect x="4" y="14" width="6" height="6" stroke="#000000" strokeWidth="2"/>
    <rect x="14" y="4" width="6" height="6" stroke="#000000" strokeWidth="2"/>
    <rect x="14" y="14" width="6" height="6" stroke="#000000" strokeWidth="2"/>
    <path d="M10 10V13H13" stroke="#000000" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

const SearchIcon = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 6H20M4 12H12M4 18H20" stroke="#000000" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

const AppStoreIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.71 19.5C17.88 20.74 17 21.95 15.66 21.97C14.32 22 13.89 21.18 12.37 21.18C10.84 21.18 10.37 21.95 9.1 22C7.79 22.05 6.8 20.68 5.96 19.47C4.25 17 2.94 12.45 4.7 9.39C5.57 7.87 7.13 6.91 8.82 6.88C10.1 6.86 11.32 7.75 12.11 7.75C12.89 7.75 14.37 6.68 15.92 6.84C16.57 6.87 18.39 7.1 19.56 8.82C19.47 8.88 17.39 10.1 17.41 12.63C17.44 15.65 20.06 16.66 20.09 16.67C20.06 16.74 19.67 18.11 18.71 19.5ZM13 3.5C13.73 2.67 14.94 2.04 15.94 2C16.07 3.17 15.6 4.35 14.9 5.19C14.21 6.04 13.07 6.7 11.95 6.61C11.8 5.46 12.36 4.26 13 3.5Z" fill="#212833"/>
  </svg>
);

const PlayStoreIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.609 1.814L13.792 12L3.609 22.186C3.221 21.817 3 21.275 3 20.702V3.298C3 2.725 3.221 2.183 3.609 1.814ZM14.852 13.06L17.297 15.505L5.629 22.186L14.852 13.06ZM18.247 9.66L20.692 11.04C21.102 11.28 21.102 11.72 20.692 11.96L18.247 13.34L15.447 10.54L18.247 9.66ZM5.629 1.814L17.297 8.495L14.852 10.94L5.629 1.814Z" fill="#212833"/>
  </svg>
);

export default LandingPage;
